import localization from 'src/localization.json'
import get from 'lodash/get'

export const getString = (key: string, locale: string) => {
  const defaultValue = get(localization, [key, 'en'], key)
  return get(localization, [key, locale], defaultValue)
}
